import { rowHasHeader } from './headers';
import type { EatonSheetKind } from './types';

export function isCoverageHeader(row: unknown[]): boolean {
  return (
    rowHasHeader(row, 'PRICE LIST ID') && rowHasHeader(row, 'CUSTOMER NUMBER')
  );
}

export function isFlatPriceHeader(row: unknown[]): boolean {
  return rowHasHeader(row, 'CATALOGUE') && rowHasHeader(row, 'DSP');
}

export function isSpaPriceHeader(row: unknown[]): boolean {
  return rowHasHeader(row, 'CATALOGUE') && !rowHasHeader(row, 'DSP');
}

/**
 * Classify one Eaton sheet. Coverage (master / regional customer lists) wins
 * over price tabs so WestburneDSP-Alb is not treated as a price dump.
 */
export function classifyEatonSheet(rows: unknown[][]): EatonSheetKind {
  const coverageRow = rows.find((row) => isCoverageHeader(row));
  if (coverageRow) return 'coverage';
  const flatRow = rows.find((row) => isFlatPriceHeader(row));
  if (flatRow) return 'flatPrices';
  const spaRow = rows.find((row) => isSpaPriceHeader(row));
  if (spaRow) return 'spaPrices';
  return 'ignored';
}
